import { Component } from '@angular/core';

@Component({
  selector: 'fp-main',
  templateUrl: './ap-facility-portal.component.html',
})
export class APFacilityPortalComponent {
  static readonly ajsComponentName = 'fpmain';
}
